import { useMemo } from "react";
import { TopTenResponse } from "../../../pages/inSeasonReviewPage/hooks/useFetchTopTen";

const TOP_TEN_LIMIT = 10;

/**
 * Hook to get selected rows sorted for sales and purchase top ten data.
 *
 * @param rowData - Optional row data to be processed
 * @returns Object containing sorted sales and purchase row data limited to top ten
 */

export function useSelectedRowsSortedTopTenData(rowData?: TopTenResponse[]) {
  return useMemo(() => {
    if (!rowData?.length) {
      return { purchaseRowData: [], salesRowData: [] };
    }

    function sortAndRank(sortField: keyof TopTenResponse) {
      return [...rowData!]
        .sort(
          (a, b) =>
            ((b[sortField] as number) ?? 0) - ((a[sortField] as number) ?? 0)
        )
        .slice(0, TOP_TEN_LIMIT)
        .map((row, index) => ({ ...row, computedRank: index + 1 }));
    }

    return {
      purchaseRowData: sortAndRank("time_purchase"),
      salesRowData: sortAndRank("nis3")
    };
  }, [rowData]);
}
